export default "__VITE_ASSET__BxC33HR1__"